//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProductListModal from '../ProductListModal.vue'
import ProductCard from '../ProductCard.vue'

export default {
  name: 'FreeGift',
  components: { ProductListModal, ProductCard },
  data () {
    return {
      overlay: false
    }
  },
  props: ['gift', 'productList', 'productFilters', 'storeDomain', 'currencySymbol'],
  methods: {
    onUpdateProduct: function() {
      this.overlay = true
      this.$emit('trigger-overlay')
    },
    onCloseOverlay: function() {
      this.overlay = false
    },
    onChooseProduct: function(product) {
      const data = {
        enable: this.gift.enable,
        productId: product.productId,
        variantId: product.variantId,
        title: product.title,
        handle: product.handle,
        image: product.image,
        variantTitle: product.variantTitle,
        requirement: this.gift.requirement,
      }
      this.$emit('gift-update', data)
    },
    giftUpdate: function(type) {
      const data = {
        enable: type === 'status' ? !this.gift.enable : this.gift.enable,
        productId: this.gift.productId,
        variantId: this.gift.variantId,
        title: this.gift.title,
        handle: this.gift.handle,
        image: this.gift.image,
        variantTitle: this.gift.variantTitle,
        requirement: this.gift.requirement,
      }
      this.$emit('gift-update', data)
    }
  },
  mounted () {

  }
}
